enum ItemType {
  Weapon,
  Magazine,
  Backpack
}

export default ItemType;